import { gql } from '@apollo/client'
import { fantasyArticleListData } from '.'

export const fantasyArticleData = `
_id
dPublishDate
dPublishDisplayDate
nCommentCount
sAmpPreview
sTitle
iMatchId
sSubtitle
oSeo {
  _id
  sSlug
  sTitle
  eType
}
sSrtTitle
sMustPick
sMatchPreview
sEditorNotes
oImg {
  sText
  sCaption
  sAttribute
  sUrl
}
oTImg {
  sText
  sCaption
  sAttribute
  sUrl
}
oOtherInfo {
  sExpertAdvice
}
oDisplayAuthor {
  eDesignation
  sDisplayName
  oSeo {
    sSlug
  }
}
dUpdated
oOverview {
  oTeam1 {
    aBenchedPlayers {
      sShortName
    }
    aPlayers {
      sPlayingRole
      sShortName
      _id
    }
    iC
    oTeam {
      sTitle
    }
  }
  oTeam2 {
    aBenchedPlayers {
      sShortName
    }
    aPlayers {
      sPlayingRole
      sShortName
      _id
    }
    iC
    oTeam {
      sTitle
    }
  }
  sWeatherReport
  sWeatherCondition
  sPitchReport
  sPitchCondition
  sOutFieldCondition
  sNews
  sMatchPreview
  sAvgScore
  oWinnerTeam {
    sTitle
    sAbbr
  }
}
sVideoUrl
ePlatformType
iCategoryId
aBudgetPicksFan {
  sDescription
  oPlayerFan {
    _id
    nRating
    oPlayer {
      _id
      sFirstName
      sPlayingRole
      oImg {
        sUrl
        sText
      }
      oSeo {
        sSlug
      }
      sShortName
    }
    eRole
    oTeam {
      sAbbr
    }
  }
}
aLeague {
  eLeague
  aTeam {
    aSelectedPlayerFan {
      _id
      oPlayer {
        _id
        sFirstName
        sShortName
        sPlayingRole
        oImg {
          sUrl
          sText
        }
      }
      nRating
      eRole
      oTeam {
        sAbbr
        _id
      }
    }
    oVCFan {
      _id
      oPlayer {
        _id
      }
      nRating
      eRole
      oTeam {
        sAbbr
      }
    }
    oCapFan {
      _id
      oPlayer {
        _id
      }
      nRating
      eRole
      oTeam {
        sTitle
        sAbbr
      }
    }
    oTPFan {
      _id
      oPlayer {
        _id
      }
      nRating
      eRole
      oTeam {
        sAbbr
      }
    }
    oTeamA {
      nCount
      oTeam {
        sTitle
        sAbbr
      }
    }
    oTeamB {
      nCount
      oTeam {
        sTitle
        sAbbr
      }
    }
  }
  eLeagueFull
}
aAvoidPlayerFan {
  sDescription
  oPlayerFan {
    oTeam {
      sAbbr
    }
    oPlayer {
      _id
      sFirstName
      sPlayingRole
      oImg {
        sUrl
      }
      sShortName
    }
    nRating
    eRole
  }
}
aCVCFan {
  sDescription
  eType
  oPlayerFan {
    oTeam {
      sAbbr
    }
    oPlayer {
      _id
      sFirstName
      sPlayingRole
      oImg {
        sUrl
        sText
      }
      oSeo {
        sSlug
      }
      sShortName
    }
    nRating
    eRole
  }
}
aTopicPicksFan {
  sDescription
  oPlayerFan {
    oTeam {
      sAbbr
    }
    oPlayer {
      _id
      sFirstName
      sPlayingRole
      oImg {
        sUrl
        sText
      }
      oSeo {
        sSlug
      }
      sShortName
    }
    nRating
    eRole
  }
}
oMatch {
  sTitle
  sStatusStr
  oStatus {
    sValue
    sText
  }
  sSubtitle
  oSeo {
    sSlug
  }
  oSeries {
    sTitle
  }
  dStartDate
  oVenue {
    sLocation
  }
  _id
  oTeamA {
    _id
    sTitle
  }
  oTeamB {
    sTitle
    _id
  }
}
oAdvanceFeature {
  bAllowComments
  bAmp
  bBrandedContent
  bEditorsPick
  bExclusiveArticle
  bFBEnable
  bRequireAdminApproval
}
nClaps
nViewCount
nOViews
nDuration
aTagsData {
  _id
  sName
  eType
  oSeo {
    sSlug
  }
}
aPlayerTag {
  _id
  oSeo {
    sSlug
  }
  eType
  sName
}
aSeriesCategory {
  _id
  oSeo {
    sSlug
  }
  eType
  sName
}
aTeamTag {
  _id
  sName
  eType
  oSeo {
    sSlug
  }
}
`

// export const FANTASY_TIPS_LIST = gql`
//   query ListMatchFantasyTipsFrontV2($input: oListMatchFantasyTipsFrontInputV2) {
//   listMatchFantasyTipsFrontV2(input: $input) {
//     aFantasyTips {
//        dStartDate
//     aMatches {
//       sTitle
//       aFantasyTips {
//         ePlatformType
//         _id
//         oSeo {
//           sSlug
//         }
//         }
//       oVenue {
//         sLocation
//       }
//       sFormatStr
//       oFormat {
//         sText
//         sValue
//       }
//       sSubtitle
//       oSeries {
//         sTitle
//         sAbbr
//         _id
//       }
//       dStartDate
//       _id
//       oTeamScoreA {
//         iTeamId
//         sScoresFull
//         sScores
//         sOvers
//         oTeam {
//           _id
//           sTitle
//           sAbbr
//           oImg {
//             sUrl
//             sText
//           }
//         }
//       }
//       oTeamScoreB {
//         iTeamId
//         sScoresFull
//         sScores
//         sOvers
//         oTeam {
//           _id
//           sTitle
//           sAbbr
//           oImg {
//             sUrl
//             sText
//           }
//         }
//       }
//       oStatus {
//         sText
//         sValue
//       }
//       nLatestInningNumber
//       sStatusNote
//     }
//     }
//     aSeries {
//       sTitle
//       sAbbr
//       _id
//     }
//   }
// }
// `

export const FANTASY_TIPS_LIST = gql`
  query ListMatchFantasyTipsFront($input: oListMatchFantasyTipsFrontInput) {
    listMatchFantasyTipsFront(input: $input) {
      aResults {
        _id
        sTitle
        sSubtitle
        sFormatStr
        oFormat {
          eType
          sCode
          sColor
          sText
          sValue
        }
        sStatusStr
        oStatus {
          eType
          sCode
          sColor
          sText
          sValue
        }
        bIsDomestic
        dStartDate
        dEndDate
        sUmpires
        sReferee
        oTeamA {
          _id
          sTitle
          sAbbr
          oImg {
            sText
            sCaption
            sAttribute
            sUrl
          }
        }
        oTeamB {
          _id
          sTitle
          sAbbr
          oImg {
            sText
            sCaption
            sAttribute
            sUrl
          }
        }
        oTeamScoreA {
          iTeamId
          sScoresFull
          sScores
          sOvers
          oTeam {
            sTitle
            _id
            sTeamKey
            sAbbr
            sTeamType
            sCountry
            sAltName
            eProvider
            eTagStatus
            bTagEnabled
            sCountryFull
            sContent
            oSocialMedia {
              oTwitter {
                sHandle
                sUrl
              }
              oFacebook {
                sHandle
                sUrl
              }
              oInstagram {
                sHandle
                sUrl
              }
              oWikipedia {
                sHandle
                sUrl
              }
            }
          }
        }
        oTeamScoreB {
          iTeamId
          sScoresFull
          sScores
          sOvers
        }
        iBattingTeamId
        oVenue {
          _id
          sName
          sLocation
          sTimezone
        }
        oSeries {
          _id
          sTitle
          sGameFormat
          sCategory
          sSeason
          dStartDate
          dEndDate
          sCountry
          sStatus
          iCategoryId
          oSeo {
            sSlug
          }
          oCategory {
            _id
            eType
            sName
            sContent
            oImg {
              sText
              sCaption
              sAttribute
              sUrl
            }
            nCount
            eStatus
            iSubmittedBy
            dUpdated
            dCreated
            oSubAdmin {
              _id
              sFName
              sEmail
              sNumber
              eStatus
              dCreated
              eGender
              sDisplayName
              sUName
              eDesignation
              sUrl
              sBio
              sAddress
              sCity
              bIsVerified
              oKyc {
                sPName
                sUrl
                sIfsc
                sANumber
                sAName
                sPanNumber
                sBankDetailPic
                sBankName
                sBranchName
              }
              bIsCustom
              aSLinks {
                eSocialNetworkType
                sDisplayName
                sLink
              }
              eType
            }
            iParentId
            oParentCategory {
              _id
              eType
              sName
              sContent
              nCount
              eStatus
              iSubmittedBy
              dUpdated
              dCreated
              iParentId
              oParentCategory {
                _id
                eType
                sName
                sContent
                nCount
                eStatus
                iSubmittedBy
                dUpdated
                dCreated
                iSeriesId
                ePlatformType
              }
              iSeriesId
              ePlatformType
            }
            iSeriesId
            ePlatformType
          }
          sAbbr
          nTotalMatches
          nTotalRounds
          nTotalTeams
          isBilateral
        }
        aFantasyTips {
          _id
          ePlatformType
          oSeo {
            sSlug
          }
        }
        oSeo {
          iId
          _id
          sTitle
          sDescription
          sSlug
          cbSlug
          aKeywords
          oFB {
            sTitle
            sDescription
            sUrl
          }
          oTwitter {
            sTitle
            sDescription
            sUrl
          }
          sCUrl
          sRobots
          eType
          eSubType
          eStatus
          eSchemaType
          bIsDeletable
          eCode
          eTabType
          aCustomSeo {
            iId
            _id
            sTitle
            sDescription
            sSlug
            cbSlug
            aKeywords
            sCUrl
            sRobots
            eType
            eSubType
            eStatus
            eSchemaType
            bIsDeletable
            eCode
            eTabType
            sContent
            sAmpContent
            sDTitle
          }
          sContent
          sAmpContent
          sDTitle
        }
        oLiveGameStatus {
          eType
          sCode
          sColor
          sText
          sValue
        }
        nLatestInningNumber
        sStatusNote
        iWinnerId
      }
    }
  }
`

export const GET_FANTASY_DETAILS = gql`
query GetFrontFantasyArticle($input: getFantasyArticleInput) {
  getFrontFantasyArticle(input: $input) {
    ${fantasyArticleData}
  }
}
`

// export const GET_FANTASY_PLAYER_DATA = gql`
// query ListFantasyPlayersInfo($input: oListFantasyPlayerInfoInput) {
//   listFantasyPlayersInfo(input: $input) {
//     eRole
//     nRating
//     oPlayer {
//       sFullName
//       _id
//     }
//     oTeam {
//       _id
//     }
//   }
// }
// `

export const GET_FANTASY_RELATED_STORIES = gql`
query GetRelatedFantasyStories($input: oGetRealatedFantasyStoriesInput) {
  getRelatedFantasyStories(input: $input) {
    ${fantasyArticleListData}
  }
}
`
